export default __webpack_public_path__ + "assets/images/386b6c33046de4736ab30bdfad2a58a1.svg";